import React from 'react'
import {Text} from 'wix-ui-tpa/cssVars'
import {classes} from './item.st.css'
import {LegendItemProps} from './index'

export const LegendItem = ({color, price, name}: LegendItemProps) => (
  <li className={classes.legendItem}>
    <div
      className={classes.color}
      style={{backgroundColor: color, border: color === '#fff' ? '1px solid black' : undefined}}
    />
    <div className={classes.textContainer}>
      <Text className={classes.name}>{name}</Text>
      <Text className={classes.price}>{price}</Text>
    </div>
  </li>
)
